module.exports = __webpack_public_path__ + "static/media/Box-with-shield-1.946a389b.png";